import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const streamsLimit: AdminBlockTypeAttribute = {
  label: 'Streams limit',
  key: 'streamsLimit',
  inputType: AdminBlockAttributeInputType.NUMBER_INPUT,
};

export default streamsLimit;
